import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductSwitchLockPeriodsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductSwitchLockPeriodsReducer.productSwitchLockPeriodsFeatureKey]
);

export const getStaticDataProductSwitchLockPeriodsFailure = createSelector(
  getStaticDataProductSwitchLockPeriodsState,
  staticDataCountriesReducer.fromStaticDataProductSwitchLockPeriodsReducer.getProductSwitchLockPeriodsFailure
);

export const getStaticDataProductSwitchLockPeriodsResponse = createSelector(
  getStaticDataProductSwitchLockPeriodsState,
  staticDataCountriesReducer.fromStaticDataProductSwitchLockPeriodsReducer.getProductSwitchLockPeriodsResponse
);

export const getStaticDataProductSwitchLockPeriodsisLoaded = createSelector(
  getStaticDataProductSwitchLockPeriodsState,
  staticDataCountriesReducer.fromStaticDataProductSwitchLockPeriodsReducer.getProductSwitchLockPeriodsIsLoaded
);
